var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5506_13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5C0 9.90202 9.40202 0.5 21 0.5C32.598 0.5 42 9.90202 42 21.5C42 33.098 32.598 42.5 21 42.5C9.40202 42.5 0 33.098 0 21.5Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5272 15.6044C25.3359 15.7489 24.7649 16.1802 24.4358 16.437C23.7766 16.9515 22.9006 17.6545 22.0272 18.4128C21.1495 19.1749 20.2946 19.9755 19.6661 20.6868C19.351 21.0434 19.1116 21.3567 18.9557 21.6152C18.8091 21.8584 18.7787 22.002 18.7787 22.002C18.7787 22.002 18.8091 22.1414 18.9557 22.3845C19.1116 22.643 19.351 22.9563 19.6661 23.313C20.2946 24.0242 21.1495 24.8248 22.0272 25.587C22.9006 26.3453 23.7766 27.0482 24.4358 27.5627C24.765 27.8195 25.3351 28.2502 25.5264 28.3947C25.9217 28.6858 26.0069 29.2429 25.7158 29.6382C25.4247 30.0335 24.8682 30.1179 24.473 29.8268L24.4698 29.8244C24.2691 29.6728 23.6778 29.2262 23.3421 28.9642C22.668 28.4381 21.7661 27.7146 20.8617 26.9294C19.9617 26.148 19.0388 25.2879 18.3339 24.4901C17.9823 24.0923 17.6662 23.6889 17.4332 23.3024C17.2149 22.9402 17 22.4817 17 21.9999C17 21.5181 17.2149 21.0595 17.4332 20.6974C17.6662 20.3108 17.9823 19.9075 18.3339 19.5096C19.0388 18.7118 19.9617 17.8518 20.8617 17.0703C21.7661 16.2851 22.6679 15.5616 23.342 15.0355C23.6781 14.7733 24.2695 14.3266 24.4697 14.1754L24.4723 14.1734C24.8676 13.8822 25.4246 13.9663 25.7158 14.3616C26.0069 14.7568 25.9224 15.3133 25.5272 15.6044Z",
    fill: "#031132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5506_13835",
    x: -30,
    y: -29.5,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5506_13835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5506_13835",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/Close X.16d2fb75279ae0c0044c9c301863e9e6.svg";
export { ForwardRef as ReactComponent };